import { createReducer, on } from '@ngrx/store';
import * as appStatusActions from '../actions/app-status.action';

export interface IAppStatusState {
  isOnline : boolean,
}

export const APP_STATUS_INITIAL_STATE: IAppStatusState = {
    isOnline : false,
};

export const AppStatusStateReducer = createReducer(
  APP_STATUS_INITIAL_STATE, 
  on(appStatusActions.AppStatusSetOnline, (state) => ({ ...state, isOnline: true })),
  on(appStatusActions.AppStatusSetOffline, (state) => ({ ...state, isOnline: false })),
);